module.exports = __webpack_public_path__ + "static/images/food-and-beverage-blue.b8c07e4f4ec93878f733ff400edf6e54.svg";